import Vue from 'vue'
import VueRouter from 'vue-router'
import LandingPageLayout from '@/views/layout/LandingPageLayout'
import LandingPage from '@/views/landing/Home'
import Remove2FA from '@/views/landing/Remove2FA'
import ResetPassword from '@/views/landing/ResetPassword'
import DashboardLayout from '@/views/layout/DashboardLayout'
import TreeLayout from '@/views/layout/TreeLayout'
import Dashboard from '@/views/dashboard/Dashboard'
import FullBinary from '@/views/dashboard/FullBinary'
import Profile from '@/views/dashboard/Profile'
import KYC from '@/views/dashboard/KYC'

// Router catch exception
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location)
    .catch(() => console.log('Routing is not changed'))
}

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: LandingPageLayout,
    redirect: { name: 'landing' },
    name: 'Home',
    children: [
      {
        path: '',
        component: LandingPage,
        name: 'landing',
        meta: {
          title: 'Home'
        }
      },
      {
        path: 'verify-email',
        component: LandingPage,
        name: 'verify-email',
        meta: {
          title: 'Verify Email'
        }
      },
      {
        path: 'remove-2fa',
        component: Remove2FA,
        name: 'remove-2fa',
        meta: {
          title: 'remove-2fa'
        }
      },
      {
        path: 'reset-password',
        component: ResetPassword,
        name: 'reset-password',
        meta: {
          title: 'Reset Password'
        }
      }
    ],
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '',
        component: Dashboard,
        name: 'Dashboard',
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'profile',
        component: Profile,
        name: 'profile',
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'kyc',
        component: KYC,
        name: 'kyc',
        meta: {
          title: 'KYC'
        }
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/binary',
    component: TreeLayout,
    children: [
      {
        path: 'organization-chart',
        component: FullBinary,
        name: 'OrganizationFullChart',
        meta: {
          title: 'Organization chart'
        }
      }
    ],
    meta: {
      requiresAuth: true
    }
  },

  { path: '*', redirect: '/dashboard', hidden: true, meta: { requiresAuth: false } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
